<template>
  <div>
    <b-container>
      <b-row>
        <template
          v-for="(route,ind) in routes"
        >
          <b-col
            v-if="route.title != 'Home' && canNavigate(route)"
            :key="ind"
            md="4"
          >
            <card-collapse
              border-variant=" "
              title-class="d-flex justify-content-between"
              :can-collapse="route.children && route.children.length ? true : false"
              :class="route.children && route.children.length ? '' : 'set-cursor'"
              @click="routerNavigate(route)"
            >
              <template #card-title>
                <feather-icon
                  :icon="route.icon"
                  size="18"
                />
                <span>{{ route.title }}</span>
              </template>
              <template>
                <nested-route :child="route" />
              </template>
            </card-collapse>
          </b-col>
        </template>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BRow, BCol } from 'bootstrap-vue'
import routes from '../../../navigation/vertical/index'
import CardCollapse from '../../../UI/CardCollapse.vue'
import NestedRoute from '../components/NestedRoute.vue'
import { canViewVerticalNavMenuLink } from '@/@core/libs/acl/utils'

export default {
  components: {
    BContainer, BRow, BCol, CardCollapse, NestedRoute,
  },
  methods: {
    canNavigate(item) {
      let hasAnyVisibleChild = false
      if (item.children && item.children.length) {
        hasAnyVisibleChild = item.children.some(i => this.$can(i.action, i.resource) && canViewVerticalNavMenuLink(i))
      }
      if (!(item.action && item.resource)) {
        return hasAnyVisibleChild
      }
      // TODO: Add recursive function to loop through grandchildrens
      return this.$can(item.action, item.resource) && canViewVerticalNavMenuLink(item)
    },
  },
  setup(_, ctx) {
    const routerNavigate = route => {
      if (!route.children) {
        ctx.root.$router.push(route.route)
      }
    }
    return {
      routes,
      routerNavigate,
    }
  },
}
</script>

<style scoped>
.set-cursor{
  cursor: pointer;
}
</style>
